<template>
  <div class="select scroll-when-error" :class="{ [theme]: theme, invalid: invalid }" :style="{ order: order || null }">
    <span v-if="label" class="label">{{ label }}</span>

    <div v-if="bars" class="select-bar">
      <template v-for="item in list">
        <div
          @click="onChange(item.value)"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          :class="{ selected: item.value == value }"
          class="select-bar__item"
        >
          {{ item.value }}
        </div>
      </template>
    </div>

    <el-select
      v-else-if="!standart"
      no-data-text="No match data"
      no-match-text="No match text"
      v-bind="rest"
      @visible-change="onVisibleChange"
      @input="onChange"
      :value="value"
      :tabindex="tabindex || null"
      :filterable="filterable"
      :disabled="disabled"
      :style="{
        ...(invalid && { animation: '0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s 1 normal both running shadow-drop-center-error' })
      }"
      :popper-class="popperClass"
    >
      <template v-for="item in list">
        <el-option :key="item.value" :label="item.label" :value="item.value">
          <div v-if="opened" class="select__label" v-html="item.text || item.label || item.value"></div>
        </el-option>
      </template>
    </el-select>

    <select
      v-else
      ref="select"
      :value="value"
      @change="onChange"
      class="el-input__inner select-standart"
      :tabindex="tabindex || null"
      :style="{
        ...(invalid && { animation: '0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s 1 normal both running shadow-drop-center-error' })
      }"
    >
      <option v-if="rest && rest.placeholder" v-html="rest.placeholder" style="display:none" :value="null"></option>
      <option v-for="item in list" :key="item.value" :value="item.value" v-html="item.text || item.label || item.value"></option>
    </select>
    <span class="error" v-show="invalid">{{ validationMessage }}</span>
  </div>
</template>

<script>
export default {
  name: "Select",
  props: [
    "standart",
    "bars",
    "list",
    "value",
    "popperClass",
    "theme",
    "label",
    "disabled",
    "tabindex",
    "order",
    "rest",
    "validation",
    "validationMessage",
    "filterable"
  ],
  data() {
    return {
      opened: false
    };
  },
  computed: {
    invalid() {
      return this.validation && this.validation.$dirty && this.validation.$invalid;
    }
  },
  methods: {
    onVisibleChange(opened) {
      this.opened = opened;
    },
    onChange(value) {
      if (!this.standart) {
        this.$emit("input", value, this.value);
      } else {
        this.$emit("input", this.$refs.select.value, this.value);
      }
      if (this.validation) {
        this.validation.$touch();
      }
    }
  }
};
</script>

<style lang="scss">
.select {
  width: 100%;
  display: flex;
  flex-direction: column;

  &.invalid {
    .label {
      color: #e74c3c;
    }
  }

  .label {
    margin-bottom: 6px;
  }

  input {
    height: 35px;
  }

  &.variant-1 {
    input,
    select {
      border: 1px solid #ddd;
      border-radius: 3px;
      background-color: rgba(255, 253, 228, 0.6);
      height: 40px;
      padding: 0 15px;

      &:focus {
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
        border-color: #409eff;
      }
    }
    select.select-standart {
      padding: 0 10px;
    }
  }
}

.el-select-dropdown {
  .popper__arrow {
    display: none;
  }
}

.el-popper[x-placement^="bottom"] {
  margin-top: 0;
}

.select-bar {
  border: 1px solid #cccccc;
  border-radius: 3px;
  display: flex;
  padding: 1px;

  &__item {
    background: #caeafa;
    border-radius: 3px;
    font-size: 20px;
    line-height: 23px;
    text-align: center;
    color: #333333;
    padding: 12px;
    display: inline-block;
    cursor: pointer;
    margin-right: 1px;
    flex-grow: 1;

    &:hover {
      background: #b6e2f9;
    }

    &.selected {
      background: #0089cc;
      color: #fff;
      font-weight: bold;
    }
  }
}
</style>
